angular.module('callX').controller('IntegrationsAllCtrl', ['$scope', 'UserService','$rootScope','$window','toaster', 'GoogleAdwordsService','MailChimpService','$state', 'DateService','$location', function($scope,UserService,$rootScope,$window, toaster, GoogleAdwordsService,MailChimpService,$state, DateService, $location) {

    $scope.currentUserData = UserService.getCurrentUserData();
    
    var getPublisherStatusAdWords = function(){
        var callbacks = {
            success: function(data) {
                $scope.publisherStatusAdwords = data.data;
                console.log($scope.publisherStatusAdwords,"this is status")
            },
            failure: function(data) {
                $scope.loadingDetailsContent = false;
            }
        };
        GoogleAdwordsService.getPublisherStatus($scope.currentUserData.id, callbacks);
    };
    //getPublisherStatusAdWords();

    var getPublisherStatusMailChimp = function(){
       var callbacks = {
            success: function(data) {
            	$scope.publisherStatusMailChimp = data.data;
            	console.log($scope.publisherStatusMailChimp,"this is status")
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        MailChimpService.getStatus($scope.currentUserData.id ,callbacks);
     };
     //getPublisherStatusMailChimp();

     $scope.deleteAdwordAccount = function(){
         var callbacks = {
            success: function (data) {
                getPublisherStatusAdWords();
        		getPublisherStatusMailChimp();
                toaster.pop('success', 'Success', 'Successfully deleted Google Adwords account', 2000);
                
            },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
         GoogleAdwordsService.deleteAccount($scope.currentUserData.id,callbacks);
    };

    $scope.goAccountDelete = function(){
        $scope.deleteAdwordAccount();
    };

    $scope.deleteMailChimpIntegration = function(){
       var callbacks = {
            success: function(data) {
            	getPublisherStatusAdWords();
        		getPublisherStatusMailChimp();
                toaster.pop('success', 'Success', 'Successfully deleted MailChimp account', 2000);
            },
            failure: function(data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
        MailChimpService.deleteIntegration($scope.currentUserData.id,callbacks)
    };

     if($scope.currentUserData.id!=undefined){
//        console.log("entered here in currentUserData.id!=undefined")
        getPublisherStatusAdWords();
        getPublisherStatusMailChimp();
    }; 

    $scope.$on('currentUserUpdate', function(event, userData) {
//        console.log("entered here in $scope.$on")
        $scope.currentUserData = userData;
        getPublisherStatusAdWords();
        getPublisherStatusMailChimp();
    });

}]);